import React from "react"
import { Col, Row, NavDropdown, Card } from "react-bootstrap"
import withHooks from "../../Common/jsx/WithHooks"
import ProgressBar from "react-bootstrap/ProgressBar"
import { FR, GB } from "country-flag-icons/react/3x2"

class QuestionHeader extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {
      isReadyToRender: true,
    }

    this.dMgr.debug("init_state:", this.state)
  }

  componentDidMount() {}

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let selectedLanguage = ""
    switch (this.props.i18n.language) {
      default:
      case "en":
        selectedLanguage = <GB title="English" className="lang_flag" />
        break
      case "fr":
        selectedLanguage = <FR title="Français" className="lang_flag" />
        break
    }

    let toRender = (
      <Row className="margin-top-15">
        <Col md={3}></Col>
        <Col md={6}>
          <Card>
            <Card.Body className="bg-dark text-white text-center">
              {/* <NavDropdown title={selectedLanguage} id="language-dropdown" className="min-width-55">
                <NavDropdown.Item onClick={() => this.props.changeLanguage("en")}>
                  <GB title="English" className="lang_flag" />
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => this.props.changeLanguage("fr")}>
                  <FR title="Français" className="lang_flag" />
                </NavDropdown.Item>
                {/*   <NavDropdown.Item onClick={() => this.changeLanguage("dplaye")}>
                      <DE title="Deutsch" className="lang_flag" />
                    </NavDropdown.Item> */}
              {/* </NavDropdown> */}
              {this.props.t("entity.question")} {this.props.selectedQuestionsCount - this.props.remainingQuestionsId.length}/{this.props.selectedQuestionsCount}
              <br />
              {/* {this.props.t("app.score")} */}
              <ProgressBar className="margin-top-8">
                {this.props.playScore.right + this.props.playScore.wrong === 0 && <ProgressBar now={100} key={1} variant="secondary" />}
                {this.props.playScore.right + this.props.playScore.wrong > 0 && (
                  <ProgressBar
                    striped
                    now={(this.props.playScore.right * 100) / (this.props.playScore.right + this.props.playScore.wrong)}
                    label={this.props.playScore.right}
                    key={1}
                    variant="success"
                  />
                )}
                {this.props.playScore.right + this.props.playScore.wrong > 0 && (
                  <ProgressBar
                    striped
                    now={(this.props.playScore.wrong * 100) / (this.props.playScore.right + this.props.playScore.wrong)}
                    label={this.props.playScore.wrong}
                    key={2}
                    variant="danger"
                  />
                )}
              </ProgressBar>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(QuestionHeader)
